<div class="flex flex-col h-full w-full overflow-hidden bg-white">
  <!-- Combined Header with Tabs -->
  <div class="relative flex px-sm pt-xs border-b border-line sticky top-0 bg-white z-10">
    <div class="flex items-center gap-md">
      <!-- Notifications Tab -->
      <button
        type="button"
        (click)="activeTab.set('notifications')"
        class="relative flex items-center px-sm py-xs text-md font-bold cursor-pointer transition-all outline-none bg-transparent border-none"
        [class.text-gradient-primary]="activeTab() === 'notifications'"
        [class.text-gray-text]="activeTab() !== 'notifications'"
      >
        {{ 'notifications' | translate }}
        @if (activeTab() === 'notifications') {
        <span
          aria-hidden="true"
          class="absolute inset-x-prop bottom-0 h-indicator bg-gradient-primary"
        ></span>
        }
      </button>

      <!-- Alerts Tab -->
      <button
        type="button"
        (click)="activeTab.set('alerts')"
        class="relative flex items-center px-sm py-xs text-md font-bold cursor-pointer transition-all outline-none bg-transparent border-none"
        [class.text-gradient-primary]="activeTab() === 'alerts'"
        [class.text-gray-text]="activeTab() !== 'alerts'"
      >
        {{ 'alerts' | translate }}
        @if (activeTab() === 'alerts') {
        <span
          aria-hidden="true"
          class="absolute inset-x-prop bottom-0 h-indicator bg-gradient-primary"
        ></span>
        }
      </button>
    </div>

    <!-- Close Button -->
    <button
      type="button"
      (click)="onClose()"
      class="absolute top-xs right-sm p-2 rounded-full cursor-pointer hover:bg-bg-soft text-gray-text hover:text-dark-text transition-colors bg-transparent border-none outline-none"
      [attr.aria-label]="'close' | translate"
    >
      <svg
        class="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>

  <!-- Content Switcher -->
  <div class="flex-1 overflow-hidden">
    @if (activeTab() === 'notifications') {
      <app-notifications class="block h-full" [isEmbedded]="true"></app-notifications>
    } @else {
      <app-updates class="block h-full" [isEmbedded]="true"></app-updates>
    }
  </div>
</div>
